import { useComebackUrl } from "@/components/hooks/use-comeback-url";
import type { AvailableSubdomain } from "@/env/config";
import { appUrl, subdomainFromUrl } from "@/utils/app-url";
import { pagesPath } from "@/utils/pages-path";
import { usePathname, useRouter } from "next/navigation";

const loginUrls: Record<AvailableSubdomain, () => string> = {
  employers: () => pagesPath.employers.login.$url().path,
  members: () => pagesPath.members.login.$url().path,
  admin: () => pagesPath.admin.login.$url().path,
};

/**
 * 未ログイン（401）の場合に、現在のURLを戻り先として保存して、現在のURLのサブドメインのログイン画面（判定できない場合はトップ）に誘導する関数を返す
 */
export const useHandleUnauthorized = () => {
  const router = useRouter();

  const { setComebackUrl } = useComebackUrl();
  const pathname = usePathname();

  return () => {
    const subdomain = subdomainFromUrl(window.location.href);

    setComebackUrl(appUrl(pathname));
    // サブドメインが判定できない場合はトップに誘導する
    router.push(subdomain ? loginUrls[subdomain]() : pagesPath.$url().path);
  };
};
